import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp, whatsapp_api_glassfish } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'


export class WhatsappUpdatePhone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPhone: '',
            loading: false,
            visible: false,
        }
    }

    updateWhatsappNumber = () => {
        console.log("upwhn1 ++++++ updateWhatsappNumber +++")
        if (this.state.newPhone.length != 10) {
            alert("phone number must be 10 digits")
        } else if (!this.state.newPhone.startsWith('07')) {
            alert("phone number must start with 07")
        }else {

            this.setState({ loading: true })


            axios.post(whatsapp_api_glassfish + 'updateWhatsappNumber', {
                apiKey: "asdf@asdfasdf",
                newPhone: this.state.newPhone,
                fbOrderKey: getOrderKey(this.props.order),
                enteredBy: this.props.user.email,
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log("upwhn12 reply:"+JSON.stringify(response.data,null,3));

                    if(response.data.result){
                        console.log("upwhn13 result is true:");
                       
                        alert(response.data.message);

                        if(response.data.newPhone){
                            console.log("upwhn14 newPhone:"+response.data.newPhone);

                            // let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                            // let orderUpdates = {
                            //     phone: response.data.newPhone,
                            //     phone_old_phone: this.props.order.phone,
                            //     phone_updated_on: now,
                            //     phone_updated_By: this.props.user.email,
                            //     whatsApp_avail:true
                            // }
                    
                            // FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);
                            //alert(response.data.message)
                        }else{
                            console.log("upwhn141 NO NEW PHONE:");
                        }

                    }else{
                        alert("Failed to update number")
                    }

                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    showUI = () => {
        console.log("setVisible")

        if (this.state.visible) {
            console.log("state is " + this.state.visible)
            this.setState({
                visible: false
            })
        } else if (!this.state.visible) {
            console.log("state is " + this.state.visible)
            this.setState({
                visible: true
            })
        }
    }

    render() {

        const sendButton = this.state.newPhone.length == 10 
            ? <Button color='green' onClick={this.updateWhatsappNumber}> UPDATE PHONE</Button>
            : ''

        const wholeUi = this.state.visible
            ? <div>
                <Form onSubmit={this.sendToClientApproved}>

                    <label>New Phone Number:{this.state.newPhone}</label>
                    <Form.Input
                        fluid
                        icon='phone'
                        iconPosition='left'
                        placeholder='New Number'
                        type='number'
                        name="newPhone"
                        value={this.state.newPhone}
                        onChange={this.handleTextInputChange}
                    />


                    {sendButton}
                </Form>

            </div>
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Button color='orange' onClick={this.showUI} fluid>UPDATE WHATSAPP PHONE</Button>
                {wholeUi}
            </div>
        )
    }
}

export default WhatsappUpdatePhone;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappUpdatePhone.js